<template>
  <data-list
    ref="dataList"
    class="content md"
    url="/admin/fire-fight-equipment"
    entity-name="器材"
    add-btn="添加器材"
    hide-show-detail
    hide-edit
    hide-delete
    show-row-num
    :action="action"
    :action-width="320"
    :rules="rules"
    :columns="columns"
    :modal-width="640"
    :modal-form="{
      layout: 'horizontal',
      labelAlign: 'left',
      labelCol: { span: 4 },
      wrapperCol: { span: 20 },
    }"
    :search-key-type="{ equipment_num: 1 }"
  >
    <template v-slot:query="{ form }">
      <a-form-model-item label="器材类型">
        <a-select
          style="width: 180px"
          placeholder="器材类型"
          @change="updateList"
          :options="typeOptions"
          v-model="form.type"
          allow-clear
        ></a-select>
      </a-form-model-item>
      <a-form-model-item label="">
        <a-input-search v-model="form.equipment_num" placeholder="输入器材编号查询" allow-clear></a-input-search>
      </a-form-model-item>
    </template>
    <template v-slot:edit="{ form }">
      <a-form-model-item label="器材类型" prop="type">
        <a-select v-model="form.type" :options="typeOptions" placeholder="请选择器材类型" allow-clear> </a-select>
      </a-form-model-item>
      <a-form-model-item label="器材数量" prop="num">
        <a-input-number
          v-model="form.num"
          placeholder="请输入器材数量"
          :min="0"
          :step="1"
          allow-clear
          style="width: 180px"
        ></a-input-number>
      </a-form-model-item>
      <a-form-model-item label="开始日期" prop="date">
        <a-month-picker v-model="form.date" placeholder="选择年月" allow-clear />
      </a-form-model-item>
    </template>
    <template v-slot:action="{ item, index }">
      <div class="row-btn">
        <a class="txt-btn" @click.stop="goRecord(item)"> 查看记录 </a>
        <a class="txt-btn" @click.stop="exportRecord(item)" :disabled="item.exporting"> 导出记录 </a>
        <a class="txt-btn" @click.stop="editRow(item, index)" v-action:update> 编辑 </a>
        <a class="txt-btn" @click.stop="showQrcode(item)"> 二维码 </a>
        <a class="txt-btn danger" @click.stop="delRow(item, index)" v-action:delete> 删除 </a>
      </div>
    </template>
  </data-list>
</template>

<script>
import { downLoadBlobFile, getKeyTitle } from "@/common/js/tool";
import { typeOptions } from "@/common/constant/equipment";
import { getTemple } from "@/common/js/storage";

export default {
  name: "Equipment",
  data() {
    return {
      columns: [
        { title: "器材编号", dataIndex: "equipment_num" },
        {
          title: "器材类型",
          dataIndex: "type",
          customRender: (text) => <span>{getKeyTitle(typeOptions, text)}</span>,
        },
        { title: "最近提交时间", dataIndex: "create_time" },
      ],
      typeOptions: typeOptions,
      rules: {
        type: [{ required: true, message: "请选择器材类型", trigger: "change" }],
        num: [{ required: true, message: "请输入器材数量", trigger: "blur" }],
        date: [{ required: true, message: "请选择开始日期", trigger: "change" }],
      },
    };
  },
  computed: {
    action() {
      return this.$route.meta.action;
    },
  },
  methods: {
    updateList() {
      this.$refs.dataList.updateList();
    },
    editRow(item, index) {
      this.$refs.dataList.editRow(item, index);
    },
    delRow(item, index) {
      this.$refs.dataList.delRow(item, index);
    },
    goRecord(item) {
      this.$router.push({ name: "EquipmentRecord", params: { id: item.id } });
    },
    exportRecord(item) {
      if (item.exporting) return;
      this.$set(item, "exporting", true);
      const temple = getTemple();
      let url = `/admin/record-fire-fight/export?temple_id=${temple}&fire_fight_equipment_id=${item.id}`;
      this.$axios(url, { noTempleFilter: true, responseType: "blob" })
        .then((res) => {
          downLoadBlobFile(res, "养护记录");
        })
        .catch(() => {
          item.exporting = false;
        });
    },
    showQrcode() {},
  },
};
</script>

<style lang="less" scoped></style>
